// **********************************************************
//  Custom Dropdown
// **********************************************************

/* eslint-disable */

$(function () {
  $('.custom-dropdown__placeholder').on('click', function () {
    $(this).parents('.custom-dropdown').toggleClass('is-dropdown-open');
  });

  $('.custom-dropdown li').on('click', function () {
    var parentElem = $(this).parents('.custom-dropdown');
    var clickedVal = $(this).html();
    parentElem.find('.custom-dropdown__placeholder').html(clickedVal);
    parentElem.removeClass('is-dropdown-open');
    $(this).siblings().removeClass('is-active');
    $(this).addClass('is-active');
  });
});

/* eslint-enable */
